import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

export function EmptyState({
  children,
  action,
  className,
}: {
  children: ReactNode
  action?: ReactNode
  className?: string
}) {
  return (
    <div className={cn('text-sm text-muted-foreground', className)}>
      <p>{children}</p>
      {action && <div className="mt-3">{action}</div>}
    </div>
  )
}
